import React from "react";
import { Container } from "react-bootstrap";
import Link from "next/link";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const BlogHero = ({ data }) => {
  return (
    <section className={s.hero}>
      <div className={s.hero_image_wrapper}>
        <img
          loading="lazy"
          src={data?.image?.url}
          alt={data?.image?.alt || "image"}
          height="100%"
        />
      </div>
      <Container>
        <div className={s.hero_content_wrapper}>
          <h1 className={s.title}>{data?.title}</h1>
          <div className={`${s.filters} d-flex align-items-center`}>
            <div className={s.category}>
              <p className={secondaryFont}>{data?.categoryTitle}</p>
            </div>
            <div>
              <p className={secondaryFont}>{data?.date}</p>
            </div>
          </div>
          <div className={`${secondaryFont} title ${s.desc}`}>
            <PrismicRichText field={data?.text || []} />
          </div>
          <Link
            href={`/blogs/${data?.buttonLink}`}
            className="btn btn-outline-dark"
          >
            View More
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default BlogHero;
